import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import matchSorter from 'match-sorter';
import {
  Badge,
  Button,
  Collapse,
} from 'reactstrap';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import FiltersResetButton from './FiltersResetButton';
import FilterTermsSelectItem from '../FilterTermsSelectItem';
import SelectVirtualMenuList from '../SelectVirtualMenuList';
import UploadFileTaxonomyMultiValue from '../Upload/FileTaxonomyMultiValue';

class FiltersFileTerms extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
    };

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  getTerm(termId) {
    const { taxonomy } = this.props;
    const termIdInt = parseInt(termId);
    const term = taxonomy.terms ? taxonomy.terms.find(t => (`${t.id}` === `${termIdInt}`)) : null;
    if (term) {
      return term;
    }

    return null;
  }

  getTaxonomyFilters() {
    const {
      availableFilters,
      taxonomy,
    } = this.props;
    return availableFilters[`taxonomy_${taxonomy.id}`] || [];
  }

  getAvailableFilters() {
    const { filters } = this.props;
    const options = [];
    this.getTaxonomyFilters().forEach((filter) => {
      if (!filters.includes(`${filter.key}`)) {
        const term = this.getTerm(filter.key);
        if (term) {
          options.push({
            value: filter.key,
            label: term.name,
          });
        }
      }
    });

    return window._.sortBy(options, [term => term.label.toLowerCase()], ['asc']);
  }

  getSelectedFilters() {
    const { filters } = this.props;
    const values = [];
    filters.forEach((filter) => {
      const term = this.getTerm(filter);
      if (term) {
        values.push({
          value: filter,
          label: term.name,
        });
      }
    });

    return values;
  }

  handleChangeFilter(values, action) {
    const {
      taxonomy,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;

    let newSelected = filters.slice(0);

    if (action.action === 'select-option') {
      const { option: value } = action;
      const term = this.getTerm(value.value);
      if (term) {
        newSelected.push(value.value);
        addFilter({
          type: 'terms',
          key: `${term.id}`,
          label: term.name,
          title: taxonomy.plural,
        });
      }
    }

    if (action.action === 'remove-value') {
      const { removedValue: value } = action;
      newSelected = newSelected.filter(s => (s !== value.value));
      removeFilter('terms', value.value);
    }

    if (action.action === 'clear') {
      this.getSelectedFilters().forEach((filter) => {
        newSelected = newSelected.filter(s => (s !== filter.value));
        removeFilter('terms', filter.value);
      });
    }

    handleChangeFilters({ terms: newSelected });
  }

  handleReset() {
    const action = {
      action: 'clear',

    };
    this.handleChangeFilter([], action);
  }

  render() {
    const { inputValue } = this.state;
    const {
      isOpen,
      taxonomy,
      handleToggleFilter,
      prefix,
      inPopover,
    } = this.props;
    const selected = this.getSelectedFilters();

    if (!selected && this.getAvailableFilters().length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-term-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{taxonomy.plural || taxonomy.name}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-term-filter-form">
            <Select
              id={`${prefix}filterFileTerms-${taxonomy.id}`}
              inputId={`filterFileTermsInput-${taxonomy.id}`}
              className="filter-select"
              classNamePrefix="filter-select"
              components={{
                MenuList: SelectVirtualMenuList,
                MultiValue: (props) => (
                  <UploadFileTaxonomyMultiValue {...props} showBlocked={true} />
                ),
                Option: FilterTermsSelectItem,
              }}
              isClearable={false}
              isMulti
              options={matchSorter(this.getAvailableFilters(), inputValue, { keys: ['label'] })}
              filterOption={false}
              onInputChange={(v) => { this.setState({ inputValue: v }); }}
              onChange={this.handleChangeFilter}
              value={selected}
              {...(inPopover ?
                {
                  menuPortalTarget: document.body,
                  styles: { menuPortal: base => ({ ...base, zIndex: 9999 }) },
                }
                : {})}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filters: props.customFilters ? props.customFilters.terms : state.Files.filters.terms,
  availableFilters: props.customAvailableFilters || state.Files.availableFilters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
});

FiltersFileTerms.propTypes = {
  filters: PropTypes.array.isRequired,
  availableFilters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  taxonomy: PropTypes.object.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
  inPopover: PropTypes.bool,
};

FiltersFileTerms.defaultProps = {
  prefix: '',
  inPopover: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersFileTerms);
